import MarketingBanner from "components/Objects/MarketingBanner";
import TwoStep from "components/Objects/TwoStep";

const Objects =  {
	MarketingBanner: MarketingBanner,
	TwoStep: TwoStep,
};

export default Objects;
